import React from 'react';
import { Button, colors, OverlaySpinner, Tooltip } from '@insurancemenu/imenu-components-lib';
import { Download, DriveFile } from '@insurancemenu/imenu-components-lib/dist/icons';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import {
  WrapperStyled,
  FileButtonStyled,
  NoDataLabelSectionStyled,
  NoDataTitleStyled,
  NoDataSubtitleStyled,
} from './styles';
import { DownloadFile } from '../DownloadFilesTable';

interface Props {
  loading?: boolean;
  file?: DownloadFile;
  onDownload: () => void;
}

const ZipFileSection: React.FC<Props> = observer(({ file, onDownload, loading = false }) => {
  const doesFileExist = !!file?.id;

  return (
    <WrapperStyled $hasFile={doesFileExist}>
      {loading ? (
        <OverlaySpinner display={loading} size="3rem" />
      ) : (
        <>
          {doesFileExist ? (
            <>
              <FileButtonStyled
                type="text"
                color="primary"
                leftIconProp={<DriveFile width="2rem" height="2rem" color={colors.blue[600]} />}
                onClick={onDownload}
              >
                {file.name}
              </FileButtonStyled>
              <Tooltip alignment={AlignmentTypes.LEFT_CENTER} label="Download zip">
                <Button type="icon" color="primary" onClick={onDownload}>
                  <Download width="2.4rem" />
                </Button>
              </Tooltip>
            </>
          ) : (
            <NoDataLabelSectionStyled>
              <NoDataTitleStyled>No ZIP file available yet</NoDataTitleStyled>
              <NoDataSubtitleStyled>The file will appear here once it&apos;s ready</NoDataSubtitleStyled>
            </NoDataLabelSectionStyled>
          )}
        </>
      )}
    </WrapperStyled>
  );
});

export default ZipFileSection;
